import Glide from "@glidejs/glide";
import { getElements, ifSelectorExist } from "./utils";

export const snyderSliders = () => {
  const communityPostsSlider = getElements(".community_posts_slider");
  if (ifSelectorExist(communityPostsSlider)) {
    Array.from(communityPostsSlider).forEach((item) => {
      new Glide(item, {
        perView: 3,
        gap: 25,
        type: "carousel",
        slideWidth: 1020,
        breakpoints: {
          1100: {
            perView: 2,
          },
          768: {
            perView: 1,
          },
        },
      }).mount();
    });
  }
};
